import { en } from "./en";

export const i18n = {
    default: en,
    en
};
